
import { SchoolStage, SchoolSettings } from '@/types/schoolSettings';
import { AlertSettings, AlertRule } from '@/types/alertSettings';

const defaultStages: SchoolStage[] = [
  {
    id: 'kindergarten',
    name: 'رياض الأطفال',
    enabled: false,
    grades: [
      { id: 'kg1', name: 'المستوى الأول', sections: ['أ'] },
      { id: 'kg2', name: 'المستوى الثاني', sections: ['أ'] },
      { id: 'kg3', name: 'المستوى الثالث', sections: ['أ'] }
    ]
  },
  {
    id: 'early_childhood',
    name: 'الطفولة المبكرة',
    enabled: false,
    grades: [
      { id: 'early1_boys', name: 'الأول الابتدائي بنين', sections: ['أ'] },
      { id: 'early1_girls', name: 'الأول الابتدائي بنات', sections: ['أ'] },
      { id: 'early2_boys', name: 'الثاني الابتدائي بنين', sections: ['أ'] },
      { id: 'early2_girls', name: 'الثاني الابتدائي بنات', sections: ['أ'] },
      { id: 'early3_boys', name: 'الثالث الابتدائي بنين', sections: ['أ'] },
      { id: 'early3_girls', name: 'الثالث الابتدائي بنات', sections: ['أ'] }
    ]
  },
  {
    id: 'elementary',
    name: 'المرحلة الابتدائية',
    enabled: true,
    grades: [
      { id: 'grade4', name: 'الرابع الابتدائي', sections: ['أ'] },
      { id: 'grade5', name: 'الخامس الابتدائي', sections: ['أ'] },
      { id: 'grade6', name: 'السادس الابتدائي', sections: ['أ'] }
    ]
  },
  {
    id: 'middle',
    name: 'المرحلة المتوسطة',
    enabled: false,
    grades: [
      { id: 'grade7', name: 'الأول المتوسط', sections: ['أ'] },
      { id: 'grade8', name: 'الثاني المتوسط', sections: ['أ'] },
      { id: 'grade9', name: 'الثالث المتوسط', sections: ['أ'] }
    ]
  },
  {
    id: 'high',
    name: 'المرحلة الثانوية',
    enabled: false,
    grades: [
      { id: 'grade10', name: 'الأول الثانوي', sections: ['أ'] },
      { id: 'grade11', name: 'الثاني الثانوي', sections: ['أ'] },
      { id: 'grade12', name: 'الثالث الثانوي', sections: ['أ'] }
    ]
  }
];

// إعدادات التنبيهات الافتراضية
export const defaultAlertSettings: AlertSettings = {
  absence_alerts: [
    {
      id: 'absence_3_default',
      threshold: 3,
      title: 'إنذار أول',
      description: 'إنذار أول وتحويل الطالب للموجه الطلابي',
      enabled: true
    },
    {
      id: 'absence_5_default',
      threshold: 5,
      title: 'إنذار ثانٍ',
      description: 'إنذار ثانٍ وإشعار ولي الأمر',
      enabled: true
    },
    {
      id: 'absence_10_default',
      threshold: 10,
      title: 'إنذار ثالث',
      description: 'إنذار ثالث واستدعاء ولي الأمر وتوقيع تعهد',
      enabled: true
    },
    {
      id: 'absence_15_default',
      threshold: 15,
      title: 'نقل إلى مدرسة أخرى',
      description: 'نقل الطالب إلى مدرسة أخرى عن طريق إدارة التعليم',
      enabled: true
    },
    {
      id: 'absence_20_default',
      threshold: 20,
      title: 'تطبيق نظام حماية الطفل',
      description: 'تطبيق ما ورد في نظام حماية الطفل',
      enabled: true
    }
  ],
  late_alerts: [
    {
      id: 'late_1_default',
      threshold: 1,
      title: 'الإجراء الأول',
      description: 'التنبيه الشفهي من المعلم/ة أو إدارة المدرسة عند مباشرة الموقف وبأسلوب تربوي حكيم، وتعزيز السلوك الإيجابي',
      enabled: true
    },
    {
      id: 'late_2_default',
      threshold: 2,
      title: 'الإجراء الثاني',
      description: 'التنبيه الشفهي للمرة الثانية من المعلم/ة أو إدارة المدرسة عند مباشرة الموقف بأسلوب تربوي حكيم وتعزيز السلوك الإيجابي',
      enabled: true
    },
    {
      id: 'late_3_default',
      threshold: 3,
      title: 'الإجراء الثالث',
      description: 'تدوين المشكلة السلوكية من المعلم/ة المباشر للموقف وتوقيع الطالب عليها',
      enabled: true
    },
    {
      id: 'late_4_default',
      threshold: 4,
      title: 'الإجراء الرابع',
      description: 'تقوم إدارة المدرسة بإشعار ولي أمر الطالب كتابياً وهاتفياً بمشكلة الطالب السلوكية، والتنسيق معه لتعديل السلوك المخالف. بعد تنفيذ الإجراء تحويل الطالب إلى الموجه/ة الطالب/ة لدراسة حالته',
      enabled: true
    },
    {
      id: 'late_5_default',
      threshold: 5,
      title: 'الإجراء الخامس',
      description: 'تقوم إدارة المدرسة بأخذ تعهد خطي على الطالب بعدم تكرار المشكلة، ودعوة ولي أمر الطالب المخالف سلوكياً وإخطاره بمشكلة الطالب السلوكية، وحسم درجة واحدة من درجات سلوك الطالب مع التمكين من فرص التعويض',
      enabled: true
    }
  ]
};

const defaultSettings: SchoolSettings = {
  schoolName: '',
  stages: defaultStages
};

const STORAGE_KEY = 'school_settings';
